import React, { useEffect, useState, useReducer, useRef } from 'react'
import { useGlobalState } from '@/state'
import WorkoutRow from '@/shared/WorkoutRow'
import Loading from '@/shared/Loading'
import { ArrowRightIcon } from '@heroicons/react/solid'

import useQuery from '@/hooks/useQuery'

const MyWorkouts = (props) => {
  const [currentUser] = useGlobalState('currentUser')
  const [attendingEvents, setAttendingEvents] = useState([])
  const isComponentMounted = useRef(false)
  const [state, setState] = useReducer(
    (state, newState) => (
      {...state, ...newState}), {
        attendingEventIds: [],
        events: [],
        classSessions: []
      }
    )
  const { attendingEventIds, classSessions, events } = state
  const { getRequest } = useQuery()
  
  useEffect(() => {
    getRequest(`/api/v1/workouts/attending`, {}, (err, jsonData) => {
      if (err) { /* handled in hook */ return }
      setAttendingEvents(jsonData.attendingEvents)
    })
    isComponentMounted.current = true

  }, [])

  if (!isComponentMounted.current) {
    return <Loading />
  }

  return <div className='max-w-7xl mx-auto'>

    <div className='mt-2 bg-white dark:bg-gray-900 rounded-lg p-2'>
      <div className="relative flex justify-between">
        <h2 className="mt-6 text-gray-900 dark:text-gray-100 text-xl font-extrabold">Workouts I'm Participating in</h2>
      </div>

      <section aria-labelledby="events-this-week">
        <div className="relative">
          { attendingEvents.length === 0 && (
            <div className="text-center py-12">
              <div className="max-w-md mx-auto">
                <div className="mx-auto h-12 w-12 text-gray-400">
                  <svg fill="none" stroke="currentColor" viewBox="0 0 48 48" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19.428 15.428a2 2 0 00-2.828 0l-13.838 13.838a2 2 0 102.828 2.828l13.838-13.838a2 2 0 000-2.828zM19.428 15.428L32.57 28.57M19.428 15.428a2 2 0 012.828 0L35.09 28.262a2 2 0 01-2.828 2.828L19.428 18.256" />
                  </svg>
                </div>
                <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-gray-100">No workouts yet</h3>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                  You haven't signed up for any workouts yet. Browse upcoming workouts to start practicing.
                </p>
                <div className="mt-6">
                  <a
                    href="/workouts"
                    className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                  >
                    Browse Workouts
                    <ArrowRightIcon className="ml-2 -mr-1 h-4 w-4" aria-hidden="true" />
                  </a>
                </div>
              </div>
            </div>
          )}
          <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
            { attendingEvents.map((event, idx) => <WorkoutRow key={`amattendevent${event.id}`} event={event} user={currentUser} attendingEventIds={[event.id.toString()]} /> )}
          </div>
        </div>
      </section>
    </div>
  </div>
}

export default MyWorkouts
